/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Browser_Ext_Page_Link_LabelInputs */

const en_browser_ext_page_link_label = /** @type {(inputs: Browser_Ext_Page_Link_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send this page to app`)
};

const es_browser_ext_page_link_label = /** @type {(inputs: Browser_Ext_Page_Link_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar esta página a la app`)
};

/**
* | output |
* | --- |
* | "Send this page to app" |
*
* @param {Browser_Ext_Page_Link_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const browser_ext_page_link_label = /** @type {((inputs?: Browser_Ext_Page_Link_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browser_Ext_Page_Link_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_browser_ext_page_link_label(inputs)
	return en_browser_ext_page_link_label(inputs)
});